import { type AnyAction } from 'redux';
import { RCE_FILE_DOWNLOADED } from '@wix/communities-blog-client-common';

const uouFileEvents = {
  [RCE_FILE_DOWNLOADED]: (action: AnyAction) => {
    return {
      evid: 219,
      ...action.payload,
      eventMeta: {
        description: 'file downloaded event',
      },
    };
  },
};

export default uouFileEvents;
